import React, { useState } from "react";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import axios from "../utils/Axios";
import { useNavigate, Link } from "react-router-dom";

const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    pbi_dashboard: true
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const { username, email } = formData;
    const newErrors = {};

    if (!username || username.trim().length < 3) {
      newErrors.username = "Username must be at least 3 characters long.";
    }

    if (!email || !email.includes("@")) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }


    try {
      setLoading(true);


      const response = await axios.post("/register", formData);

      if (response.status === 200) {
        toast.success(response.data.message);
        localStorage.setItem("username", formData.username);
        localStorage.setItem("email", formData.email);
        localStorage.setItem('timeLeft', 600);
        toast.success(response.message);
        navigate("/verify-email");
      }
    } catch (error) {
      console.log('Error while registering:', error);
      toast.error(error.response.data.error);
    } finally {
      setLoading(false);
    }

  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="absolute inset-0 flex items-center justify-center">
        {/* Background decorations */}
        <div className="absolute inset-0 bg-gradient-to-r from-green-200 via-yellow-200 to-brown-200 opacity-75 z-0"></div>

        <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg bg-white text-gray-700 p-8 rounded-md md:rounded-lg lg:rounded-2xl shadow-md z-10">
          <h1 className="text-2xl font-bold text-center mb-6 md:text-3xl lg:text-4xl">
            <span className="text-gray-700">Register at</span>{" "}
            <span className="text-green-600">Katyayani</span>
          </h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Username Field */}
            <div>
              <label
                htmlFor="username"
                className="block font-semibold text-gray-600 mb-1"
              >
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={`w-full px-4 py-3 border rounded-md ${errors.username
                  ? "border-red-500 focus:border-red-600"
                  : "border-green-400 focus:border-green-600"
                  }`}
                placeholder="Enter your username"
              />
              {errors.username && (
                <p className="text-sm text-red-500 mt-1">{errors.username}</p>
              )}
            </div>

            {/* Email Field */}
            <div>
              <label
                htmlFor="email"
                className="block font-semibold text-gray-600 mb-1"
              >
                Email
              </label>
              <input
                type="text"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full px-4 py-3 border rounded-md ${errors.email
                  ? "border-red-500 focus:border-red-600"
                  : "border-green-400 focus:border-green-600"
                  }`}
                placeholder="Enter your email"
              />
              {errors.email && (
                <p className="text-sm text-red-500 mt-1">{errors.email}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full px-4 py-3 text-white rounded-md font-semibold transition ${loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-500 hover:bg-green-600"
                }`}
            >
              {loading ? (
                <div className="flex justify-center items-center gap-2">
                  <BeatLoader size={8} color="#fff" />
                  <span>Registering...</span>
                </div>
              ) : (
                "Register"
              )}
            </button>

            {/* General Error */}
            {errors.general && (
              <p className="text-sm text-red-500 text-center mt-2">
                {errors.general}
              </p>
            )}

            {/* Links */}
            <div className="text-center mt-6 text-sm">
              <span>Already have an account?</span>{" "}
              <Link
                to="/login"
                className="text-green-600 font-semibold hover:text-green-700"
              >
                Log In
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
